module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-3743480ad039630f13632f9c7aa5be7e.webp";